$(document).ready(function(){

  $('.btn--readless').on('click', function(e){
    var accordion = $(this).parents('details');
    $(this).parents('details').removeClass('open').removeAttr('open');
    $('html, body').animate({
      scrollTop: $(accordion).offset().top - 100
    }, 'slow');
  });

  /* ================================================== */
  /* SUMMARY / DETAILS FOR NO SUPPORT
  /* ================================================== */  

  $('html').addClass($.fn.details.support ? 'details' : 'no-details');

  $('details').details();

  if (!$.fn.details.support) {
    $('details').attr('open', false);
  }
  

});